export default "__VITE_PUBLIC_ASSET__f69ca5bc__"